import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  roofNo: 0,
  abstacleNo: 0,
  allRoof: true,
  electricalConfiguration: "All Roof",
  roofData: [],
};

export const quantityInfo = createSlice({
  name: "quantityInfo",
  initialState: initialState,
  reducers: {
    updateQuantityInfo: (state, action) => {
      return { ...state, ...action.payload };
    },
    updateRoofDetails: (state, action) => {
      const { index, fields } = action.payload;
      state.roofData[index] = {
        ...state.roofData[index],
        ...fields,
      };
    },
    updateRoofInverterAnalysis: (state, action) => {
      const { index, fields } = action.payload;
      const updatedRoofData = [...state.roofData];
      updatedRoofData[index] = {
        ...updatedRoofData[index], 
        inverterAnalysis: {
          ...updatedRoofData[index].inverterAnalysis, 
          ...fields,
        },
      };
      state.roofData = updatedRoofData;
    },
    updateRoofFinancialAnalysis: (state, action) => {
      const { index, fields } = action.payload;
      const updatedRoofData = [...state.roofData];
      updatedRoofData[index] = {
        ...updatedRoofData[index], 
        financialAnalysis: {
          ...updatedRoofData[index].financialAnalysis, 
          ...fields,
        },
      };
      state.roofData = updatedRoofData;
    },
    resetQuantityInfo: (state, action) => {
      return initialState;
    },
  },
});

export const {
  updateQuantityInfo,
  resetQuantityInfo,
  updateRoofDetails,
  updateRoofInverterAnalysis,
  updateRoofFinancialAnalysis
} = quantityInfo.actions;

export default quantityInfo.reducer;
